import axios from 'axios';
import API_BASE_URL from '../config.js';

const availability = async (data) => {
    const response = await axios.post(`${API_BASE_URL}/available/`, data
    );
    return response;

};

export default availability;
